'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import posthog from 'posthog-js';

// Short-lived credentials that ride URL query strings must never reach
// PostHog: `claim_token` (underwriter claim verification, spec
// underwriters/2026-07-06-001 §7.3) and `__clerk_ticket` (Clerk invitation
// ticket). Values are replaced, params kept, so funnels remain analysable.
const SENSITIVE_QUERY_PARAMS = ['claim_token', '__clerk_ticket'] as const;

function sanitizeUrl(href: string): string {
  try {
    const url = new URL(href);
    for (const param of SENSITIVE_QUERY_PARAMS) {
      if (url.searchParams.has(param)) url.searchParams.set(param, 'redacted');
    }
    return url.toString();
  } catch {
    return href;
  }
}

export function PageTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== 'undefined' && posthog.__loaded) {
      posthog.capture('$pageview', {
        $current_url: sanitizeUrl(window.location.href),
        path: pathname
      });
    }
  }, [pathname]);

  return null;
}
